export default __webpack_public_path__ + "static/media/rules-football-bg-desktop.13eb3d31.jpg";